import { Route, Navigate } from "react-router-dom";
import { useState } from "react";
import AdminLoginPage from "../pages/admin_login";
import Admin from "../pages/admin";
import Questionaier from "../components/categoryoptions/questionaire";
import AddNewQuestionaire from "../components/categoryoptions/addnewquestionaire";
import EditQuestion from "../components/categoryoptions/editquestion";
import ViewReports from "../components/categoryoptions/viewreports";
import SelectDomain from "../components/categoryoptions/selectdomain";
import RequireAuth from "../auth/requireAuth";
import MaturityAssessment from "../components/categoryoptions/maturityassessment";
import CategoryForm from "../pages/categoryForm";
import ScoreLevelsForm from "../pages/scores";
import SettingsDashboard from "../components/categoryoptions/admin-landingpage";
import AdminDashboard from "../pages/AdminDashboard";

export default function AdminRoutes() {
  return (
    <>
      <Route path="/admin-login" element={<AdminLoginPage />} />

      <Route
        path="/admin/*"
        element={
          <RequireAuth>
            <Admin />
          </RequireAuth>
        }
      >
        <Route path=":domain/admin-landingpage" element={<SettingsDashboard />}/>
        <Route path=":domain/score-levels" element={<ScoreLevelsForm />} />
        <Route index element={<Navigate to="select-domain" replace />} />
        <Route path="select-domain" element={<SelectDomain />} />
        <Route path="admin-dashboard" element={<AdminDashboard />} />


        <Route path=":domain/questionaire" element={<Questionaier />} />

        <Route path=":domain/add-new-questionaire" element={<AddNewQuestionaire />} />
        <Route path=":domain/edit-questionaire" element={<EditQuestion />} />
        <Route path=":domain/view-reports" element={<ViewReports />} />
        <Route path=":domain/view-reports/:email" element={<MaturityAssessment />} />
        <Route path=":domain/category" element={<CategoryForm />} />
      </Route>
    </>
  );
}
